import React, { useState } from "react";
import { Plus } from "lucide-react";
import { format } from "date-fns";
import { fmt, categoryLabel } from "./financeUtils";

/**
 * İşlemler listesi (artifact `.tx`).
 * txs: enriched FinanceTransaction[] (displayTitle, orgName included).
 * onRowClick(tx) opens the detail sheet; canAdd → "İŞLEM EKLE".
 */
const PAGE = 15;

const TransactionsList = ({ txs, title, canAdd, onAdd, onRowClick }) => {
  const [limit, setLimit] = useState(PAGE);
  const visible = txs.slice(0, limit);

  return (
    <section>
      <div className="flex justify-between items-center gap-2 mx-1 mb-2">
        <h2 className="fin-grot text-[14px] font-semibold text-[var(--fin-text)] min-w-0 truncate">
          {title} ({txs.length})
        </h2>
        <div className="flex items-center gap-3 shrink-0">
          <span className="text-[11px] text-[var(--fin-muted)] hidden sm:inline">
            işleme dokun → detay
          </span>
          {canAdd && (
            <button
              onClick={onAdd}
              className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.08em] px-3 py-1.5 rounded-full bg-[var(--fin-pos-soft)] text-[var(--fin-pos)] hover:opacity-80 transition-opacity"
            >
              <Plus className="w-3 h-3" /> İşlem Ekle
            </button>
          )}
        </div>
      </div>
      <div className="fin-card">
        {visible.length ? (
          visible.map((t) => {
            const isIn = t.type === "income";
            return (
              <button
                key={t.id}
                onClick={() => onRowClick(t)}
                className="w-full flex items-center gap-[11px] px-4 py-[11px] border-b border-[var(--fin-row-line)] last:border-b-0 hover:bg-[var(--fin-hover)] transition-colors text-left"
              >
                <div
                  className="w-[34px] h-[34px] rounded-[10px] grid place-items-center text-[14px] shrink-0"
                  style={{
                    background: isIn ? "var(--fin-pos-soft)" : "var(--fin-neg-soft)",
                    color: isIn ? "var(--fin-pos)" : "var(--fin-neg)",
                  }}
                >
                  {isIn ? "↘" : "↗"}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-[12.5px] font-semibold text-[var(--fin-text)] truncate">
                    {t.displayTitle}
                  </div>
                  <div className="text-[10.5px] text-[var(--fin-muted)] truncate">
                    {[
                      t.transactionDate
                        ? format(new Date(t.transactionDate), "dd/MM/yyyy")
                        : null,
                      t.orgName,
                      categoryLabel(t.category),
                    ]
                      .filter(Boolean)
                      .join(" · ")}
                  </div>
                </div>
                <div
                  className="fin-grot fin-num font-semibold text-[13px] text-right shrink-0"
                  style={{ color: isIn ? "var(--fin-pos)" : "var(--fin-neg)" }}
                >
                  {isIn ? "+" : "−"}
                  {fmt(t.amount)}
                </div>
                <span className="text-[#c4cbc8] text-[14px] shrink-0">›</span>
              </button>
            );
          })
        ) : (
          <div className="px-4 py-[26px] text-center text-[12.5px] text-[var(--fin-muted)]">
            Bu dönemde işlem yok.
          </div>
        )}
        {txs.length > limit && (
          <button
            onClick={() => setLimit((l) => l + 30)}
            className="w-full py-2.5 text-[11px] font-bold uppercase tracking-[0.08em] text-[var(--fin-blue)] hover:bg-[var(--fin-hover)] transition-colors border-t border-[var(--fin-line)]"
          >
            Daha fazla göster (+{txs.length - limit})
          </button>
        )}
      </div>
    </section>
  );
};

export default TransactionsList;
